<template>
  <v-card class="mx-auto" :loading="loading">
    <v-card-title class="primary--text">
      <span 
        class="font-weight-light" 
        :class="$style.cardTitle"
      >
        Số Liệu Quan Trắc
      </span>
    </v-card-title>
    <v-card-text :class="$style.envFrame">
      <iframe 
        :src="envIframe" 
        id="widgeturl" 
        width="100%" 
        height="100%" 
        scrolling="no" 
        frameborder="0" 
        allowtransparency="true" 
        style="border:none;overflow:hidden;"
        @load="iframeIsLoaded"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapState([
      'config'
    ]),
    envIframe(){
      return `${this.config.beUrl}/environment-iframe`;
    }
  },
  methods: {
    iframeIsLoaded () {
      this.loading=false;
    }
  }
}
</script>
<style module>
  .envFrame{height: 350px;}
  .cardTitle{font-size: 16px;}
</style>